import { useEffect } from "react";
import { batch, useSignal } from "@preact/signals-react";
import { useAppToast } from "@ui-seeker/app"
import { isEmpty, scrollToComponent, postSubmit } from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import { stockAssDetailsNotListedFilters } from "../../@signals";


export default function useStockAssortmentNotListedSearch() {

	const { showToast } = useAppToast()

	const dataNotListed = useSignal([])
	const isLoadingNotListed = useSignal(false)
	const tableTitle = useSignal("")

    useEffect(() => {
		if (!isEmpty(stockAssDetailsNotListedFilters.value)) batch(() => {
			isLoadingNotListed.value = true
            dataNotListed.value = []
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/stock-assortment/details/all-products`, stockAssDetailsNotListedFilters.value).then(res => batch(() => {
                dataNotListed.value = res
                isLoadingNotListed.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('not-listed-table')))
		}) 

		if (isEmpty(stockAssDetailsNotListedFilters.value)) batch( () => {
			dataNotListed.value = {}
			tableTitle.value = ""
		})

	}, [JSON.stringify(stockAssDetailsNotListedFilters.value)]);

    const resetNotListedData = () => batch(() => {
		dataNotListed.value = {}
		tableTitle.value = ""
		stockAssDetailsNotListedFilters.value = {}
	})


	return {
		dataNotListed: dataNotListed.value,
		isLoadingNotListed: isLoadingNotListed.value,
        resetNotListedData
	}
}
